import { Alert, AlertTitle } from '@mui/material';
import { useLocalization } from '../../providers/LocalizationProvider';

function FormWarnings({ errors }) {
  if (!errors) {
    return null;
  }
  let currentErrors = [];
  if (Array.isArray(errors)) {
    currentErrors = errors;
  } else if (typeof errors === 'object') {
    currentErrors = [errors];
  } else {
    currentErrors = [{ message: JSON.stringify(errors) }];
  }

  const { formatMessage } = useLocalization();
  if (currentErrors && currentErrors.length > 0) {
    return (
      <Alert sx={{ mb: 2, mt: -1 }} severity="warning">
        <AlertTitle>
          {formatMessage({
            id: 'WARNINGS',
            defaultMessage: 'Warnings',
          })}
        </AlertTitle>
        <ul>
          {currentErrors.map((error, index) => {
            return <li key={error?.message || index}>{error?.message}</li>;
          })}
        </ul>
      </Alert>
    );
  }
  return null;
}

export default FormWarnings;
